export default __webpack_public_path__ + "static/media/lock.a36eb1be.svg";